import React, { useState } from 'react';
import { Row, Col, Steps, Button, notification } from 'antd';
import { DownloadOutlined } from "@ant-design/icons";
import Card from './Card'
import ApplicationDenialModal from './ApplicationDenialModal';
import { STATES, DOCUMENT_TYPES } from '../../../helpers/constants';
import { getDayDiff, getUrlPath } from "../../../helpers/parsers";

import ApplicationService from "../../../services/ApplicationService";

const { Step } = Steps;

const ApplicationStateBar = ({ application, appState, setPrintedDocuments, appChange }) => {
    const disabled = !application?.customer?.emailVerified;

    const [cancelDialogVisible, setCancelDialogVisible] = useState(false)

    const print = () => {
        ApplicationService.printPdf(application.uuId).then(({ documentsPrinted }) => {
            //update printed documents in application to use in other components
            setPrintedDocuments(documentsPrinted)

            const { completeSheet } = application
            ApplicationService.getPdf(getUrlPath(completeSheet))
                .then(response => response.blob())
                .then(data => {
                    let newWindow = window.open('');
                    newWindow.location.href = URL.createObjectURL(data);
                    newWindow.focus();
                })
        })
    };

    const complete = () => {
        ApplicationService.completeApplication(application.uuId).then((app) => {
            if (app) {
                appChange({
                    ...application,
                    state: app.state,
                    updated: app.updated
                });
                notification.success({
                    message: 'Ապրանքը բաց թողնվեց։',
                    className: 'ant-notification',
                });
            }
        })
    }

    const cancel = ({ state, reason, otherReasonMessage }) => {
        ApplicationService.deny(application.uuId, { state, reason, otherReasonMessage })
            .then((app) => {
                debugger;
                appChange({ 
                    ...application, 
                    state: app.state, 
                    status: app.status
                 })
            })
            .finally(() => setCancelDialogVisible(false))
    }


    const { documentsPrinted, attachments } = application;
    var currentStep;
    switch (appState) {
        case STATES.agreed:
            currentStep = 0;
            break;
        case STATES.signed:
            if (attachments && attachments.length > 0) {
                currentStep = 3;
            } else if (documentsPrinted.indexOf(DOCUMENT_TYPES.RECEIPT_SHEET) !== -1) {
                currentStep = 2;
            } else {
                currentStep = 1;
            }
            break;
        case STATES.finished:
            currentStep = 4;
            break;
        default:
            currentStep = -1;
            break;
    }

    return (
        <>
            <Card>
                <Row type="flex" justify="space-between" align="middle">
                    <Col type="flex" span={16}>
                        <Steps current={currentStep} size="small">
                            <Step title="Ավարտել գործարքը" />
                            <Step title="Տպել ստացականը" />
                            <Step title="Ներբեռնել ստորագրված փաստաթուղթը" />
                            <Step title="Տրամադրել ապրանքը" />
                        </Steps>
                    </Col>
                    {(appState === STATES.signed && application.attachments && application.attachments.length > 0) && (
                        <Col>
                            <Button size={"large"} className='btn-yellow' onClick={complete}>
                                Տրամադրել ապրանքը
                            </Button>
                        </Col>
                    )}
                    {(appState === STATES.signed || appState === STATES.agreed || (appState === STATES.finished && getDayDiff(application.updated) < 2)) && (
                      <Col>
                          <Button
                            size='large'
                            onClick={print}
                            disabled={disabled}
                            className={`${disabled ? '' : 'btn-purple'} mr-1`}
                          >
                              <DownloadOutlined/>
                              Տպել Փաստաթղթերը
                          </Button>
                          {appState !== STATES.finished && (
                            <Button
                              size='large'
                              className='btn-red mr-1'
                              onClick={() => setCancelDialogVisible(true)}
                            >
                                Չեղարկել
                            </Button>
                          )}
                      </Col>
                    )}
                </Row>
            </Card>
            {cancelDialogVisible && <ApplicationDenialModal onFinish={cancel} onCancel={() => setCancelDialogVisible(false)}/>}
        </>
    )

}

export default ApplicationStateBar;